import { render, staticRenderFns } from "./swipers.vue?vue&type=template&id=442905ad&scoped=true"
import script from "./swipers.vue?vue&type=script&lang=js"
export * from "./swipers.vue?vue&type=script&lang=js"
import style0 from "./swipers.vue?vue&type=style&index=0&id=442905ad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442905ad",
  null
  
)

export default component.exports